module.exports = __webpack_public_path__ + "static/media/your_logo.6d167e4d.png";